import axios from "axios";
import authHeader from '../../authheader'

const STAFFDASHBOARDURL = process.env.REACT_APP_APIURL + "/api/Staff";

const getDashboardNumbers = async () => {
    return axios.get(`${STAFFDASHBOARDURL}/dashboard`, { headers: authHeader() });;
};
const getDashboardInternalStatusNumbers = async () => {
    return axios.get(`${STAFFDASHBOARDURL}/dashboardinternalstatuses`, { headers: authHeader() });;
};

const getDashboardDualLicenseCount = async () => {
    return axios.get(`${STAFFDASHBOARDURL}/dashboardduallicense`, { headers: authHeader() });;
};
const getDashboardNewlyLicensed = async (startDate, endDate) => {
    return axios.get(`${STAFFDASHBOARDURL}/dashboardnewlylicensed`, { headers: authHeader(), params: { startDate, endDate } });;
};
const getDashboardLicenseStatuses = async () => {
    return axios.get(`${STAFFDASHBOARDURL}/dashboardlicensestatuses`, { headers: authHeader() });;
};
const getDashboardApplicationStatusCounts = async (startDate, endDate) => {
    return axios.get(`${STAFFDASHBOARDURL}/dashboardapplicationstatuses`, { headers: authHeader(), params: { startDate, endDate } });;
};
const getDashboardReactivationCounts = async (startDate, endDate) => {
    return axios.get(`${STAFFDASHBOARDURL}/dashboardreactivationstatuses`, { headers: authHeader(), params: { startDate, endDate } });;
};
const getDashboardRenewalCountsByCycle = async () => {
    return axios.get(`${STAFFDASHBOARDURL}/dashboardrenewalcountsbycycle`, { headers: authHeader() });;
};

export default {
    getDashboardNumbers,
    getDashboardInternalStatusNumbers,
    getDashboardDualLicenseCount,
    getDashboardLicenseStatuses,
    getDashboardNewlyLicensed,
    getDashboardApplicationStatusCounts,
    getDashboardRenewalCountsByCycle,
    getDashboardReactivationCounts
}
